// extracted by mini-css-extract-plugin
export default {"snackbar":"Y_6WG865","notificationAction":"ynYbfWHM"};